import { MAX_LISTING_IMPORT_FILES } from '../constants/listing-import-max-files';

function isListingImportCsvFile(file: File): boolean {
  const name = file.name.toLowerCase();
  if (name.endsWith('.csv')) {
    return true;
  }

  const type = file.type.toLowerCase();
  return (
    type === 'text/csv' ||
    type === 'application/csv' ||
    type === 'application/vnd.ms-excel'
  );
}

export function filterListingImportCsvFiles(files: File[]): {
  accepted: File[];
  skippedNonCsvCount: number;
} {
  const accepted: File[] = [];
  let skippedNonCsvCount = 0;

  for (const file of files) {
    if (isListingImportCsvFile(file)) {
      accepted.push(file);
    } else {
      skippedNonCsvCount += 1;
    }
  }

  return { accepted, skippedNonCsvCount };
}

export function capListingImportFiles(files: File[]): {
  files: File[];
  capped: boolean;
} {
  if (files.length <= MAX_LISTING_IMPORT_FILES) {
    return { files, capped: false };
  }

  return { files: files.slice(0, MAX_LISTING_IMPORT_FILES), capped: true };
}

export function prepareListingImportFiles(files: File[]): {
  accepted: File[];
  skippedNonCsvCount: number;
  capped: boolean;
} {
  const { accepted: csvFiles, skippedNonCsvCount } =
    filterListingImportCsvFiles(files);
  const { files: accepted, capped } = capListingImportFiles(csvFiles);

  return { accepted, skippedNonCsvCount, capped };
}
